export function InRequest(params = {}) {
  return {
    type: '@telatransmitecentral/IN_REQUEST',
    payload: { params },
  };
}

export function findRecord(post_cod_posto) {
  return {
    type: '@telatransmitecentral/FIND',
    payload: { post_cod_posto },
  };
}

export function failedRequest() {
  return {
    type: '@telatransmitecentral/FAILED_REQUEST',
  };
}

export function deleteRecord(post_cod_posto, params) {
  return {
    type: '@telatransmitecentral/DELETE',
    payload: { post_cod_posto, params },
  };
}

export function updateRecord(telatransmitecentral, params) {
  return {
    type: '@telatransmitecentral/UPDATE',
    payload: { telatransmitecentral, params },
  };
}

export function storeRecord(telatransmitecentral, params) {
  return {
    type: '@telatransmitecentral/STORE',
    payload: { telatransmitecentral, params },
  };
}

export function successInRequest(
  telatransmitecentral,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@telatransmitecentral/SUCCESS_IN_REQUEST',
    payload: { telatransmitecentral, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(telatransmitecentral) {
  return {
    type: '@telatransmitecentral/SUCCESS_REQUEST',
    payload: { telatransmitecentral },
  };
}

export function successRemove(params) {
  return {
    type: '@telatransmitecentral/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@telatransmitecentral/RECORD_FILTERING',
    payload: { params },
  };
}
